import { z } from 'zod';
// Deutsche Fehlermeldungen für alle Schemas dieses Pakets (Rahmenbedingung 1).
z.config(z.locales.de());
/**
 * IDs sind laut Anhang A UUIDv7-Strings. Das Schema prüft nur „nicht leer“,
 * damit kurze Test- und Beispiel-IDs ("doc-01") gültig bleiben; neue IDs
 * erzeugt {@link newId}.
 */
export const idSchema = z.string().min(1, { error: 'ID darf nicht leer sein' });
/** Millimeter mit 0,1 mm Auflösung. Negative Werte sind erlaubt (Platzierung im Rand). */
export const mmSchema = z
    .number({ error: 'Länge in mm erwartet' })
    .finite({ error: 'Länge muss eine endliche Zahl sein' })
    .transform(roundMm);
/** Rundet auf die Modellauflösung von 0,1 mm. */
export function roundMm(value) {
    return Math.round(value * 10) / 10;
}
export const COLOR_TOKENS = [
    'solution',
    'placeValue.ones',
    'placeValue.tens',
    'placeValue.hundreds',
    'placeValue.thousands',
    'text',
    'accent',
];
export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;
/** Farbe als `#rrggbb` oder als Token-Name (Anhang A: `type Color = string`). */
export const colorSchema = z.string().refine(isColor, {
    error: 'Farbe muss "#rrggbb" oder ein Farb-Token sein',
});
export function isColor(value) {
    return HEX_COLOR.test(value) || COLOR_TOKENS.includes(value);
}
export const isoDateTimeSchema = z.string().refine((value) => !Number.isNaN(Date.parse(value)), {
    error: 'Zeitangabe muss ISO 8601 sein',
});
export const gradeSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);
export const localeSchema = z.enum(['de-DE', 'de-AT', 'de-CH', 'en-US']);
export const rangeSchema = z.object({ from: z.number().int(), to: z.number().int() });
/** UUIDv7 für neue Objekte (Zeitstempel + Zufall, lexikografisch sortierbar). */
export function newId(now = Date.now(), random = Math.random) {
    const bytes = new Uint8Array(16);
    const ts = BigInt(now);
    for (let i = 0; i < 6; i += 1) {
        bytes[i] = Number((ts >> BigInt(8 * (5 - i))) & 0xffn);
    }
    for (let i = 6; i < 16; i += 1) {
        bytes[i] = Math.floor(random() * 256) & 0xff;
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x70;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
    return [
        hex.slice(0, 8),
        hex.slice(8, 12),
        hex.slice(12, 16),
        hex.slice(16, 20),
        hex.slice(20),
    ].join('-');
}
//# sourceMappingURL=common.js.map